<template lang="pug">
.vip-wrapper(v-if="!loading")
  .vipinfo(:class="{'epic-vip' : turnoverDetails[0].vip_next === null}")
    .iimg
      img(:src="'assets/img/vip/'+turnoverDetails[0].vip_id+'.png'")
      span {{ turnoverDetails[0].vip_name }}
      //- small -
    .ccon
      .t {{accountID}}
      .m
        template(v-if="turnoverDetails[0].vip_next !== null")
          .lwrap
            .levelbar(v-if="showDepo")
              .levmsg Deposit : 
                span {{ $numeral(totalDeposit).format("0,0.00") }}
                | / {{ $numeral(turnoverDetails[0].deposit_next).format("0,0.00") }}
              .levbar
                span(:style="'width:'+depoProgress+'%'")
            .levelbar(v-if="showTo")
              .levmsg Turnover : 
                span {{ $numeral(totalTurnover).format("0,0.00") }}
                | / {{ $numeral(turnoverDetails[0].turnover_next).format("0,0.00") }}
              .levbar
                span(:style="'width:'+toProgress+'%'")
          .lnext
            i Next Level
            img(:src="'assets/img/vip/'+turnoverDetails[0].vip_next+'.png'")
            span {{ turnoverDetails[0].vip_name_next }}
          //- small -
      .b Maintain Deposit : 
        span {{ $numeral(turnoverDetails[0].cycle_deposit).format("0,0.00") }} / {{ $numeral(turnoverDetails[0].maintain_deposit).format("0,0.00") }}
      .b Maintain Turnover :
        span {{ $numeral(turnoverDetails[0].cycle_turnover).format("0,0.00") }} / {{ $numeral(turnoverDetails[0].maintain_turnover).format("0,0.00") }}
      .b * Next Possible Level : 
        span {{ turnoverDetails[0].possible_vip_name_next }}
  .vipslide-wrapper
    .slider.slider-vip
      div(v-for="info in chart")
        .vipcard
          .iimg
            img(:src="'assets/img/vip/'+info.level+'.png'")
          .ccon
            .ttitle {{info.vip_name}}
              //- span Level 1
            //- .ttext Deposit : 
              span 0
            //- .ttext Turnover : 
              span 0
  .vipslidecon-wrapper
    .slider.slider-vipcon
      .vipslide-table(v-for="info in chart")
        .table-responsive
          table(width='100%')
            tr
              td Total Deposit Needed
              td {{ $numeral(info.deposit).format("0,0") }}  
            tr
              td Total Turnover Needed
              td {{ $numeral(info.turnover).format("0,0") }}  
            tr
              td Maintain Deposit
              td {{ $numeral(info.maintain_deposit).format("0,0") }}  
            tr
              td Maintain Turnover
              td {{ $numeral(info.maintain_turnover).format("0,0") }}  
            tr
              td Level Up Reward
              td(v-if="info.cash !== null") {{ $numeral(info.cash).format("0,0") }}
              td(v-else) -
            tr
              td Reward Type
              td(v-if="info.reward_type !== null") {{info.reward_type}}
              td(v-else) -
            tr
              td Daily Rebate
              td {{ getDisplay(info.vip_name, "rebateSlot")}}
            tr 
              td Daily Rebate(Live Casino & SportBook)
              td {{ getDisplay(info.vip_name, "rebateOthers")}}
            tr
              td Daily Rescue
              td {{ getDisplay(info.vip_name, "rescue")}}
            tr
              td Daily Referral
              td {{ getDisplay(info.vip_name, "referral")}}
</template>
<script>
export default{
  data(){
    return{
      loading:true,
      turnoverDetails: [],
      chart:[],
      depoProgress: 0,
      toProgress: 0,
      totalDeposit: 0,
      totalTurnover: 0,
      showDepo: false,
      showTo: false,
      rewardInfo:{
        'Bronze1': {
          rebateSlot: "0.10%",
          rebateOthers: "0.10%",
          rescue: "-",
          referral: "0.50%"
        },
        'Bronze2': {
          rebateSlot: "0.10%",
          rebateOthers: "0.10%",
          rescue: "-",
          referral: "0.50%"
        },
        'Bronze3': {
          rebateSlot: "0.10%",
          rebateOthers: "0.10%",
          rescue: "-",
          referral: "0.50%"
        },
        'Bronze4': {
          rebateSlot: "0.10%",
          rebateOthers: "0.10%",
          rescue: "2%",
          referral: "0.50%"
        },
        'Silver1': {
          rebateSlot: "0.10%",
          rebateOthers: "0.10%",
          rescue: "2.5%",
          referral: "0.50%"
        },
        'Silver2': {
          rebateSlot: "0.15%",
          rebateOthers: "0.15%",
          rescue: "2.5%",
          referral: "0.50%"
        },
        'Silver3': {
          rebateSlot: "0.20%",
          rebateOthers: "0.15%",
          rescue: "2.5%",
          referral: "0.50%"
        },
        'Silver4': {
          rebateSlot: "0.25%",
          rebateOthers: "0.15%",
          rescue: "2.5%%",
          referral: "0.50%"
        },
        'Gold1': {
          rebateSlot: "0.30%",
          rebateOthers: "0.30%",
          rescue: "3%",
          referral: "0.50%"
        },
        'Gold2': {
          rebateSlot: "0.35%",
          rebateOthers: "0.30%",
          rescue: "3%",
          referral: "0.50%"
        },
        'Gold3': {
          rebateSlot: "0.40%",
          rebateOthers: "0.30%",
          rescue: "3%",
          referral: "0.50%"
        },
        'Gold4': {
          rebateSlot: "0.45%",
          rebateOthers: "0.30%",
          rescue: "3.50%",
          referral: "0.50%"
        },
        'Platinum1': {
          rebateSlot: "0.50%",
          rebateOthers: "0.50%",
          rescue: "4%",
          referral: "0.50%"
        },
        'Platinum2': {
          rebateSlot: "0.55%",
          rebateOthers: "0.50%",
          rescue: "4%",
          referral: "0.55%"
        },
        'Platinum3': {
          rebateSlot: "0.60%",
          rebateOthers: "0.50%",
          rescue: "4%",
          referral: "0.60%"
        },
        'Platinum4': {
          rebateSlot: "0.65%",
          rebateOthers: "0.50%",
          rescue: "4.50%",
          referral: "0.65%"
        },
        'Diamond1': {
          rebateSlot: "0.85%",
          rebateOthers: "0.75%",
          rescue: "5%",
          referral: "0.85%"
        },
        'Diamond2': {
          rebateSlot: "0.90%",
          rebateOthers: "0.75%",
          rescue: "5.50%",
          referral: "0.90%"
        },
        'Diamond3': {
          rebateSlot: "0.95%",
          rebateOthers: "0.75%",
          rescue: "6%",
          referral: "0.95%"
        },
        'Diamond4': {
          rebateSlot: "1%",
          rebateOthers: "0.75%",
          rescue: "7%",
          referral: "1%"
        },
        'EpicVIP': {
          rebateSlot: "1.20%",
          rebateOthers: "0.85%",
          rescue: "8%",
          referral: "1.20%"
        },
      }
    }
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
  },
  watch:{
    sessionToken(newState, oldState){
      var vm = this
      if(newState === '' || newState === undefined){
        vm.$router.push("/").catch(err => {});
      }
    }
  },
  updated(){
    if(this.chart.length > 0){
      $('.slider-vip').slick({
          arrows: false,
          centerMode: true,
          slidesToShow: 3,
          centerPadding: '0',
          asNavFor: '.slider-vipcon'
      });

      $('.slider-vipcon').slick({
          arrows: false,
          asNavFor: '.slider-vip',
          accessibility: false,
          draggable: false
      });
    }
  },
  mounted(){
    $('link[rel="canonical"]').attr('href', `${window.location.protocol}//${window.location.hostname}/vip`);
    this.getMemberVip()
  },
  methods:{
    getDisplay(name, target){
      if(this.rewardInfo[name]){
        if(this.rewardInfo[name][target]){
          return this.rewardInfo[name][target]
        }
      }else{
        return "-"
      }
      // return this.rewardInfo[target].rebateSlot
    },
    getMemberVip(){
      if (this.sessionToken) {
        this.loading = true
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getMemberVip", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              this.turnoverDetails = response.data.deposit_turnover
              this.chart = response.data.next_level
              this.totalDeposit = this.turnoverDetails[0].starting_deposit + this.turnoverDetails[0].cycle_deposit
              this.totalTurnover = this.turnoverDetails[0].starting_turnover + this.turnoverDetails[0].cycle_turnover
              this.depoProgress = ( this.totalDeposit / this.turnoverDetails[0].deposit_next) * 100
              this.toProgress = (this.totalTurnover / this.turnoverDetails[0].turnover_next) * 100
              if(this.turnoverDetails[0].deposit_next !== 0){
                this.showDepo = true
              }
              if(this.turnoverDetails[0].turnover_next !== 0){
                this.showTo = true
              }
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
            this.loading = false
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            this.loading = false
          })
        }
    }
  }
}

</script>
<style lang="scss">
.epic-vip .iimg{
  margin: 0 !important;
}
</style>